import * as E from 'fp-ts/Either';
import { config } from '../config';
import { ErrorResponse } from './common';

export type Token = {
  userId: string;
  token: string;
  expiresAt: string;
};

export const login = async (
  username: string,
  password: string
): Promise<E.Either<ErrorResponse, Token>> => {
  const result = await fetch(`${config.apiUrl}/cms/v1/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username, password }),
  });

  return result.status === 200
    ? E.right(await result.json())
    : E.left(await result.json());
};
